module.exports = __webpack_public_path__ + "static/media/delete-item.6d8b2fa9.svg";